import { cn } from '../../utils/cn'

type SpinnerSize = 'sm' | 'md' | 'lg'

const SIZE_CLASSES: Record<SpinnerSize, string> = {
  sm: 'w-4 h-4 border-2',
  md: 'w-6 h-6 border-2',
  lg: 'w-10 h-10 border-3',
}

export function LoadingSpinner({
  size = 'md',
  className,
}: {
  size?: SpinnerSize
  className?: string
}) {
  return (
    <div
      className={cn(
        'animate-spin rounded-full border-[var(--accent)] border-t-transparent',
        SIZE_CLASSES[size],
        className,
      )}
      role="status"
      aria-label="Chargement"
    />
  )
}
